<script lang="ts">
  import * as Pager from "./types";
  export let customClass: string = "";
  export let onPageRequested: ((page: number) => void) | undefined;
  export let data: Pager.Data | null;

  let currentPage: number = 1;
  $: currentPage = data ? data.page : 1;

  let currentRangeStart: number;
  $: currentRangeStart = data ? (data.page - 1) * data.pageSize + 1 : 1;

  const backClicked = () => {
    if (1 < currentPage) {
      currentPage = currentPage - 1;
      if (onPageRequested) {
        onPageRequested(currentPage);
      }
    }
  };

  const nextClicked = () => {
    if (data?.noPages && currentPage == data.noPages) {
      return;
    }

    currentPage += 1;
    if (onPageRequested) {
      onPageRequested(currentPage);
    }
  };
</script>

<div class={`pl-[8px] text-nowrap ${customClass}`}>
  <!-- Text left -->
  {#if data && data.pageCount && data.totalCount}
    <span>{currentRangeStart}–{currentRangeStart + data.pageCount - 1} av {
        data.totalCount
      }</span>
  {/if}
  <!-- Left/right buttons -->
  <button on:click={backClicked} class="inline p-[12px] hover:opacity-[75%]">
    <img src="/icons/arrow-left-small.svg" alt="arrow-left" />
  </button>
  <button
    on:click={nextClicked}
    class="inline p-[12px] hover:opacity-[75%]"
    disabled={!data?.noPages || currentPage >= data.noPages}
  >
    <img src="/icons/arrow-right-small.svg" alt="arrow-right" />
  </button>
</div>
